module.exports = __webpack_public_path__ + "img/T25.9f0e979d.jpg";